import { Toaster as Sonner } from "sonner"
import { useTheme } from "../../../context/theme"

/** Theme-aware sonner mount point — one instance for the whole app, rendered in main.tsx. */
export function Toaster() {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "rounded-xl border shadow-lg",
        },
      }}
    />
  )
}
